import { DependentEntityInfo } from "@common/types";
import { WeightsSetDependenciesReadModel } from "@Criteria/Weights/Domain/readmodels";

export class WeightsSetDeleterViewModel
{
    opened: boolean = false;

    initialized: boolean = false;
    weightsSetId: number | null = null;
    weightsSetName: string | null = null;
    hasDependants: boolean | null = null;
    dependenciesCount: number | null = null;
    weightedScores: DependentEntityInfo[] = [];

    show(weightsSetId: number, weightsSetName: string)
    {
        this.initialized = false;
        this.weightsSetId = weightsSetId;
        this.weightsSetName = weightsSetName;
        this.hasDependants = null;
        this.dependenciesCount = null;
        this.weightedScores = [];

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.initialized = false;
        this.weightsSetId = null;
        this.weightsSetName = null;
        this.hasDependants = null;
        this.dependenciesCount = null;
        this.weightedScores = [];
    }

    setData(data: WeightsSetDependenciesReadModel)
    {
        this.hasDependants = data.HasDependants;
        this.dependenciesCount = data.DependenciesCount;
        this.weightedScores = data.WeightedScores;

        this.initialized = true;
    }
}